import { useState } from "react";
import { PasswordInput } from "@/components/shop/PasswordInput";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";
import { api, formatApiError } from "@/lib/api";

const inp = "h-11 w-full rounded-xl border border-black/15 bg-white px-3 text-sm outline-none focus:border-amber-500";

export const ChangePassword = () => {
  const [f, setF] = useState({ current_password: "", new_password: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    if (f.new_password !== f.confirm) return toast.error("Le due password non coincidono");
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: f.current_password, new_password: f.new_password });
      toast.success("Password aggiornata");
      setF({ current_password: "", new_password: "", confirm: "" });
    } catch (err) { toast.error(formatApiError(err)); } finally { setBusy(false); }
  };
  return (
    <form onSubmit={submit} className="rounded-2xl border border-black/10 bg-white p-5" data-testid="change-password">
      <p className="flex items-center gap-2 font-display text-lg font-bold"><KeyRound className="h-5 w-5 text-amber-600" />Cambia password</p>
      <div className="mt-3 grid gap-3 sm:grid-cols-3">
        <PasswordInput required value={f.current_password} onChange={set("current_password")} placeholder="Password attuale" className={inp} data-testid="change-password-current" />
        <PasswordInput required minLength={8} value={f.new_password} onChange={set("new_password")} placeholder="Nuova (min. 8 caratteri)" className={inp} data-testid="change-password-new" />
        <PasswordInput required minLength={8} value={f.confirm} onChange={set("confirm")} placeholder="Ripeti la nuova" className={inp} data-testid="change-password-confirm" />
      </div>
      <button disabled={busy} className="mt-3 rounded-full bg-black px-5 py-2 text-sm font-bold text-white disabled:opacity-50" data-testid="change-password-submit">{busy ? "Salvataggio..." : "Aggiorna password"}</button>
    </form>
  );
};
